import type { AnyObj } from '@repo/internal-tools-type-utils/src/primitives.ts'

/**
 * Shallow equality check for plain objects.
 *
 * - Compares own enumerable string keys via `Object.keys()`.
 * - Compares values using `Object.is()` (so NaN equals NaN).
 * - Does not do deep equality (nested objects are compared by reference).
 */
export const checkIsObjShallowEqual = (
  objA: AnyObj | undefined,
  objB: AnyObj | undefined,
): boolean => {
  if (objA === objB) return true
  if (!objA || !objB) return false

  const keysA = Object.keys(objA)
  const keysB = Object.keys(objB)

  if (keysA.length !== keysB.length) return false

  for (const key of keysA) {
    if (!Object.prototype.hasOwnProperty.call(objB, key)) return false
    if (!Object.is(objA[key], objB[key])) return false
  }

  return true
}
